import { Box, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_CIRCULAR_PROGRESS_BAR_BACKGROUND,
  DARK_PROGRESS_OVERLAY_BACKGROUND,
  GRAY_CIRCULAR_PROGRESS_BACKGROUND,
  LIGHT_PROGRESS_OVERLAY_BACKGROUND,
} = COLORS;

export const ProgressCont = styled(Box)(({ theme }) => ({
  alignSelf: 'center',
  minWidth: 50,
  overflow: 'hidden',
  backgroundColor:
    theme.palette.type === 'dark' ? DARK_CIRCULAR_PROGRESS_BAR_BACKGROUND : GRAY_CIRCULAR_PROGRESS_BACKGROUND,
}));

export const Completed = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? DARK_PROGRESS_OVERLAY_BACKGROUND : LIGHT_PROGRESS_OVERLAY_BACKGROUND,
  transition: '300ms',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
